import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { RotateCcw, XCircle } from "lucide-react";
import { toast } from "react-toastify";
import { cancelAdminOrder, refundAdminOrder } from "../../../actions/adminOrderActions";
import { formatMoney, humanize } from "../orderViewUtils";
import OrderFinancialDialog from "./OrderFinancialDialog";

export function hasFinancialPermission(user = {}) {
  const roles = Array.isArray(user.roles) ? user.roles : String(user.roles || user.role || "").split(",");
  return roles.some((role) => ["admin", "super_admin"].includes(String(role).trim().toLowerCase()));
}

export default function AdminOrderFinancialActions({ order, onRefresh, busy }) {
  const dispatch = useDispatch();
  const [action, setAction] = useState("");
  const cancellation = order.adminActions?.cancellation || {};
  const refund = order.adminActions?.refund || {};
  const textile = cancellation.containsTextile;

  async function confirm(payload) {
    try {
      const data = await dispatch((action === "cancel" ? cancelAdminOrder : refundAdminOrder)({ orderNumber: order.orderNumber, ...payload }));
      const status = data.refundAction?.status;
      toast.success([data.message, status ? humanize(status) : "", data.refundAction?.providerRefundId].filter(Boolean).join(" · "));
    } finally {
      await onRefresh();
    }
  }

  return (
    <section className="admin-order-manage__panel" id="order-financial-actions">
      <header><h2>{textile ? "Exceptional Textile cancellation / refund" : "Cancellation / refund"}</h2></header>
      {!cancellation.cancellable && cancellation.reason ? <p>{cancellation.reason}</p> : null}
      <div className="admin-order-manage__hero-actions">
        {cancellation.cancellable ? <button type="button" className="admin-order-manage__ghost-btn" disabled={busy} onClick={() => setAction("cancel")}>
          <XCircle size={16} /><span>{textile ? "Textile cancellation override" : order.cancellation?.review?.status === "requested" ? "Approve cancellation" : "Cancel order"}</span>
        </button> : null}
        {refund.refundable ? <button type="button" className="admin-order-manage__ghost-btn" disabled={busy} onClick={() => setAction("refund")}>
          <RotateCcw size={16} /><span>{textile ? "Textile refund override" : "Refund order"} ({formatMoney(refund.amount, order.currency)})</span>
        </button> : null}
      </div>
      {order.refunds?.length ? <ul className="mt-3">{order.refunds.map((entry, index) => <li key={entry._id || index}>
        {formatMoney(entry.amount, order.currency)} · {humanize(entry.provider)} · {humanize(entry.status)}{entry.providerRefundId ? ` · ${entry.providerRefundId}` : ""}
      </li>)}</ul> : null}
      {action ? <OrderFinancialDialog key={action} action={action} amount={refund.amount || cancellation.remainingRefundAmount || 0}
        currency={order.currency} provider={order.payment?.provider} textile={textile} refundRequired={cancellation.refundRequired}
        onClose={() => setAction("")} onConfirm={confirm} /> : null}
    </section>
  );
}
